import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';

const enhance = compose(pure);

const VenueSuggestionItem = ({
  activeRef,
  t,
  className,
  address,
  handleClick,
}) => {
  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      ref={activeRef}
    >
      <div className="address">{address.company_name}</div>
      <div className="subaddress">{address.fullAddress}</div>
    </button>
  );
};

VenueSuggestionItem.propTypes = {
  activeRef: PropTypes.func,
  className: PropTypes.string,
  t: PropTypes.func,
  address: PropTypes.shape({}),
  handleClick: PropTypes.func,
};

VenueSuggestionItem.defaultProps = {
  className: '',
  t: (k) => k,
  address: {},
  handleClick: () => {},
  activeRef: () => {},
};

export default enhance(VenueSuggestionItem);
